import './index.css';
import 'react-step-progress-bar/styles.css';
import { ProgressBar, Step } from 'react-step-progress-bar';
import { View } from '../../../component';
import Constants from '../../../constants';
import { s } from '../../../utilities/scaling_utils';
import useTheme from '../../../utilities/hooks/theme';
import React from 'react';

interface Props {
  questionList?: any;
  currentStep?: any;
}

const YNQuestionStep = ({ questionList, currentStep }: Props) => {
  const { FantasyTheme: theme } = useTheme();
  return (
    <View
      style={{
        marginLeft: s(25),
        marginRight: s(25)
      }}
      className={'YNQuestionStep_container'}>
      <ProgressBar
        width={s(220)}
        percent={100 * (currentStep / questionList.length)}
        filledBackground={theme.myQueAnsStepFilledBG}
        unfilledBackground={theme.myQueAnsStepUnFilledBG}
        height={'4px'}>
        {questionList.map((index: any) => {
          return (
            <Step key={index}>
              {({ accomplished }: any) => {
                return (
                  <>
                    {accomplished ? (
                      <View
                        style={{
                          width: '20px',
                          height: '20px',
                          borderRadius: '10px',
                          justifyContent: 'center',
                          backgroundColor: theme.myQueAnsStepAccomplishBG
                        }}>
                        <img src={Constants.Images.Ball} />
                      </View>
                    ) : (
                      <View
                        style={{
                          width: '10px',
                          height: '10px',
                          borderRadius: '5px',
                          justifyContent: 'center',
                          backgroundColor: theme.myQueAnsStepAccomplishBG
                        }}
                      />
                    )}
                  </>
                );
              }}
            </Step>
          );
        })}
      </ProgressBar>
    </View>
  );
};
export default React.memo(YNQuestionStep);
